import React from 'react';
import { Edit, SimpleForm } from 'react-admin';

import { CustomToolbar, Grid } from '../../components'
import StudentEnrollmentFields from './StudentEnrollmentFields'

export const StudentEnrollmentEdit = props => (
  <Edit {...props}>
    <SimpleForm toolbar={<CustomToolbar />}>
      <Grid container spacing={8}>
        <StudentEnrollmentFields />
      </Grid>
    </SimpleForm>
  </Edit>
);

export default StudentEnrollmentEdit
